import { NgModule } from "@angular/core";
import { Routes, RouterModule, ExtraOptions } from "@angular/router";
import { DynamicFormComponent } from "./dynamic-form/dynamic-form.component";
import { DynamicFormDataEntryComponent } from "./dynamic-form-data-entry/dynamic-form-data-entry.component";
import { DynamicGridComponent } from "./dynamic-grid/dynamic-grid.component";
import { DynamicViewComponent } from "./dynamic-view/dynamic-view.component";
import { DynamicEditComponent } from "./dynamic-edit/dynamic-edit.component";
import { SignInComponent } from "./sign-in/sign-in.component";
import { LoginComponent } from "./sign-in/login/login.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { ResetPasswordEmailComponent } from "./sign-in/reset-password/reset-password-email.component";
import { ResetPasswordEmailSentComponent } from "./sign-in/reset-password-completed/reset-password-email-sent.component";
import { ResetPasswordContactComponent } from "./sign-in/reset-password-get-help/reset-password-contact.component";
import { MyDashboardComponent } from "./my-dashboard/my-dashboard.component";
import { FriendInvitationComponent } from "./friend-invitation/friend-invitation.component";
import { CharityInvitationSentComponent } from "./friend-invitation/charity-invitation-sent/charity-invitation-sent.component";
import { MyDelegatesComponent } from "./my-delegates/my-delegates.component";
import { DelegateSummaryComponent } from "./my-delegates/delegate-summary/delegate-summary.component";
import { PaymentComponent } from "./payment/payment.component";
import { PaymentChoosePlanComponent } from "./payment/payment-choose-plan/payment-choose-plan.component";
import { PaymentChooseProfessionalComponent } from "./payment/payment-choose-professional/payment-choose-professional.component";
import { PaymentMonthlySubscriptionComponent } from "./payment/payment-monthly-subscription/payment-monthly-subscription.component";
import { RequestAccessComponent } from "./request-access/request-access.component";
import { RequestAccessPlanComponent } from "./request-access/request-access-plan/request-access-plan.component";
import { RequestSubmittedComponent } from "./request-access/request-submitted/request-submitted.component";
import { SharedPlansComponent } from "./shared-plans/shared-plans.component";
import { SignUpComponent } from "./sign-up/sign-up.component";
import { SignUpReferralCodeComponent } from "./sign-up/sign-up-referral-code/sign-up-referral-code.component";
import { SignUpPasswordComponent } from "./sign-up/sign-up-password/sign-up-password.component";
import { SignUpCompletedComponent } from "./sign-up/sign-up-completed/sign-up-completed.component";
import { DelegateHomePageComponent } from "./delegate-home-page/delegate-home-page.component";
import { DelegateInvitationSentComponent } from "./my-delegates/delegate_invitation_sent/delegate-invitation-sent.component";
import { AccountSettingsComponent } from "./account-settings/account-settings.component";
import { FinancialSummariesComponent } from "./financial-summaries/financial-summaries.component";
import { DeletedItemsComponent } from "./deleted-items/deleted-items.component";
import { PlanReviewComponent } from "./plan-review/plan-review.component";
import { SharedPlanSummaryComponent } from "./shared-plans/shared-plan-summary/shared-plan-summary.component";
import { ProfessionalHomePageComponent } from "./professional-home-page/professional-home-page.component";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { AccountsComponent } from "./admin-dashboard/accounts/accounts.component";
import { ProfessionalsComponent } from "./admin-dashboard/professionals/professionals.component";
import { PartnersComponent } from "./admin-dashboard/partners/partners.component";
import { AnalyticsComponent } from "./admin-dashboard/analytics/analytics.component";
import { ListsComponent } from "./admin-dashboard/lists/lists.component";
import { MonitoringComponent } from "./admin-dashboard/monitoring/monitoring.component";
import { CopyEditorComponent } from "./admin-dashboard/copy-editor/copy-editor.component";
import { RolesComponent } from "./admin-dashboard/roles/roles.component";
import { MailLogComponent } from "./admin-dashboard/mail-log/mail-log.component";
import { AdminDashboardUserDetailsComponent } from "./admin-dashboard-user-details/admin-dashboard-user-details.component";
import { AccountDetailsComponent } from "./admin-dashboard-user-details/account-details/account-details.component";
import { ProfessionalsDetailsComponent } from "./admin-dashboard-user-details/professionals-details/professionals-details.component";
import { CommonModule } from "@angular/common";
import { SponsorPageComponent } from "./sponsor-page/sponsor-page.component";
import { SuggestedNextStepsComponent } from "./suggested-next-steps/suggested-next-steps.component";
import { MailRulesComponent } from "./admin-dashboard/mail-rules/mail-rules.component";
import { SuggestionRulesComponent } from "./admin-dashboard/suggestion-rules/suggestion-rules.component";
import { ProfessionalManagerHomePageComponent } from "./professional-manager-home-page/professional-manager-home-page.component";
import { SecurityPageComponent } from "./security-page/security-page.component";
import { PaymentSubcriptionComponent } from "./payment-subcription/payment-subcription.component";
import { EventsLogComponent } from "./events-log/events-log.component";
import { ResourcesComponent } from "./admin-dashboard/resources/resources.component";
import { RefcodesComponent } from "./admin-dashboard/refcodes/refcodes.component";
import { AuditLogComponent } from "./admin-dashboard/auditlog/auditlog.component";
import { UnlockRequestComponent } from "./admin-dashboard/unlock-request/unlock-request.component";
import { MailQueueComponent } from "./admin-dashboard/mail-queue/mail-queue.component";
import { MailLogDetailsComponent } from "./admin-dashboard-user-details/mail-log-details/mail-log-details.component";
import { SecurityPageSignUpComponent } from "./security-page-sign-up/security-page-sign-up.component";
import { MfaComponent } from "./sign-up/mfa/mfa.component";
import { TwoFactorAuthComponent } from "./sign-up/two-factor-auth/two-factor-auth.component";
import { XTestingComponent } from "./x-testing/x-testing.component";
import { AddClientsComponent } from "./professional-home-page/add-clients/add-clients.component";
import { UploadProfessionalsListComponent } from "./professional-home-page/upload-professionals-list/upload-professionals-list.component";
import { EmailTemplateComponent } from "./professional-home-page/email-template/email-template.component";
import { EmailPreviewComponent } from "./professional-home-page/email-preview/email-preview.component";
import { InviteOnlyComponent } from "./professional-home-page/invite-only/invite-only.component";
import { ClientAccessPageComponent } from "./admin-dashboard/client-access-page/client-access-page.component";
import { DelegateReferralComponent } from "./admin-dashboard/delegate-referral/delegate-referral.component";
import { ChatBoxDetailComponent } from "./delegate-home-page/chat-box-detail/chat-box-detail.component";
import { CreateAccountComponent } from "./professional-home-page/create-account/create-account.component";
import { AccountCreatedComponent } from "./professional-home-page/account-created/account-created.component";

const routes: Routes = [
  { path: "", component: SignUpReferralCodeComponent },
  { path: "", redirectTo: "/sign-in", pathMatch: "full" },
  { path: "sign-in", component: LoginComponent },
  { path: "my-dashboard", component: MyDashboardComponent },
  { path: "friend-invitation", component: FriendInvitationComponent },
  {
    path: "charity-invitation-sent",
    component: CharityInvitationSentComponent,
  },
  { path: "my-delegates", component: MyDelegatesComponent },
  { path: "delegate-summary", component: DelegateSummaryComponent },
  { path: "payment", component: PaymentComponent },
  { path: "payment-choose-plan", component: PaymentChoosePlanComponent },
  {
    path: "payment-choose-licenses",
    component: PaymentChooseProfessionalComponent,
  },
  {
    path: "payment-monthly-subscription",
    component: PaymentMonthlySubscriptionComponent,
  },
  { path: "request-access", component: RequestAccessComponent },
  { path: "request-access/:Id", component: RequestAccessComponent },
  { path: "request-access-plan", component: RequestAccessPlanComponent },
  { path: "request-access-plan", component: RequestAccessPlanComponent },
  { path: "request-access-plan/:Id", component: RequestAccessPlanComponent },
  { path: "request-submitted", component: RequestSubmittedComponent },
  { path: "shared-plans", component: SharedPlansComponent },
  {
    path: "my-wishes",
    redirectTo: "/dynamicform/my-wishes",
    pathMatch: "full",
  },
  {
    path: "my-wishes/:id",
    redirectTo: "/dynamicform/my-wishes",
    pathMatch: "full",
  },
  { path: "sign-up", component: SignUpComponent },
  { path: "sign-up/:refCode", component: SignUpComponent },
  { path: "sign-up-referral-code", component: SignUpReferralCodeComponent },
  { path: "sign-up-password", component: SignUpPasswordComponent },
  { path: "sign-up-completed", component: SignUpCompletedComponent },
  { path: "mfa", component: MfaComponent },
  { path: "auth", component: TwoFactorAuthComponent },
  { path: "delegate-home-page", component: DelegateHomePageComponent },
  { path: 'chat-box/:messageId', component: ChatBoxDetailComponent },
  { path: "admin-dashboard", component: AdminDashboardComponent },
  { path: "accounts", component: AccountsComponent },
  { path: "professionals", component: ProfessionalsComponent },
  { path: "partners", component: PartnersComponent },
  { path: "analytics", component: AnalyticsComponent },
  { path: "analytics", component: AnalyticsComponent },
  { path: "lists", component: ListsComponent },
  { path: "monitoring", component: MonitoringComponent },
  { path: "copyeditor", component: CopyEditorComponent },
  { path: "mail-rules", component: MailRulesComponent },
  { path: "resources", component: ResourcesComponent },
  { path: "suggestion-rules", component: SuggestionRulesComponent },
  { path: "roles", component: RolesComponent },
  { path: "mail-log", component: MailLogComponent },
  { path: "mail-log-details/:Id", component: MailLogDetailsComponent },
  { path: "events-log", component: EventsLogComponent },
  {
    path: "admin-dashboard-user-details/:Id",
    component: AdminDashboardUserDetailsComponent,
  },
  { path: "account-details", component: AccountDetailsComponent },
  { path: "professionals-details", component: ProfessionalsDetailsComponent },
  {
    path: "account-settings",
    redirectTo: "/account-settings/aboutMe",
    pathMatch: "full",
  },
  { path: "account-settings/:section", component: AccountSettingsComponent },
  { path: "deleted-items", component: DeletedItemsComponent },
  { path: "plan-review", component: PlanReviewComponent },
  {
    path: "plan-review/assets",
    redirectTo: "/plan-review/assets",
    pathMatch: "full",
  },
  {
    path: "plan-review/debts",
    redirectTo: "/plan-review/debts",
    pathMatch: "full",
  },
  {
    path: "plan-review/dailyLife",
    redirectTo: "/plan-review/dailyLife",
    pathMatch: "full",
  },
  {
    path: "plan-review/wishes",
    redirectTo: "/plan-review/wishes",
    pathMatch: "full",
  },
  { path: "plan-review/:id", component: PlanReviewComponent },
  { path: "professional-home-page", component: ProfessionalHomePageComponent },
  { path: "home", component: MyDashboardComponent, pathMatch: "full" },
  { path: "my-plan", redirectTo: "/dynamicform/my-plan", pathMatch: "full" },
  {
    path: "my-assets",
    redirectTo: "/dynamicform/my-assets",
    pathMatch: "full",
  },
  {
    path: "my-assets/:id",
    redirectTo: "/dynamicform/my-assets",
    pathMatch: "full",
  },
  { path: "suggested-next-steps", component: SuggestedNextStepsComponent },
  {
    path: "professional-manager-home-page",
    component: ProfessionalManagerHomePageComponent,
  },
  { path: "security-page", component: SecurityPageComponent },
  { path: "security-page-sign-up", component: SecurityPageSignUpComponent },
  { path: "payment-subscription", component: PaymentSubcriptionComponent },
  { path: "refcodes", component: RefcodesComponent },
  { path: "auditlog", component: AuditLogComponent },
  { path: "unlock-request", component: UnlockRequestComponent },
  { path: "mail-queue", component: MailQueueComponent },
  { path: "client-access-page", component: ClientAccessPageComponent },
  { path: "delegate-referral", component: DelegateReferralComponent },

  // Professionals
  { path: "add-clients", component: AddClientsComponent },
  {
    path: "upload-professionals-list",
    component: UploadProfessionalsListComponent,
  },
  { path: "email-template", component: EmailTemplateComponent },
  { path: "email-preview", component: EmailPreviewComponent },
  { path: "invite-only", component: InviteOnlyComponent },
  { path: "create-account", component: CreateAccountComponent },  
  { path: "account-created", component: AccountCreatedComponent },  

  // Assets
  {
    path: "pensions",
    redirectTo: "/dynamicformdataentry/pension_1",
    pathMatch: "full",
  },
  {
    path: "pension-new/:newItem",
    redirectTo: "/dynamicgrid/pensions-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "pension-edit-save/:editItem",
    redirectTo: "/dynamicgrid/pensions-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "pension-intro",
    redirectTo: "/dynamicformdataentry/pension-intro",
    pathMatch: "full",
  },
  {
    path: "pension-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/pension-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "pension_joint-owners",
    redirectTo: "/dynamicformdataentry/pension_joint-owners",
    pathMatch: "full",
  },
  {
    path: "pension_1",
    redirectTo: "/dynamicformdataentry/pension_1",
    pathMatch: "full",
  },
  {
    path: "pension_2",
    redirectTo: "/dynamicformdataentry/pension_2",
    pathMatch: "full",
  },
  {
    path: "pension_3_1",
    redirectTo: "/dynamicformdataentry/pension_3_1",
    pathMatch: "full",
  },
  {
    path: "pension_3_2",
    redirectTo: "/dynamicformdataentry/pension_3_2",
    pathMatch: "full",
  },
  {
    path: "pension_3_1_1",
    redirectTo: "/dynamicformdataentry/pension_3_1_1",
    pathMatch: "full",
  },
  {
    path: "pension_3_1_2",
    redirectTo: "/dynamicformdataentry/pension_3_1_2",
    pathMatch: "full",
  },
  {
    path: "pension_3_2_1",
    redirectTo: "/dynamicformdataentry/pension_3_2_1",
    pathMatch: "full",
  },
  {
    path: "pension_3_2_2",
    redirectTo: "/dynamicformdataentry/pension_3_2_2",
    pathMatch: "full",
  },
  {
    path: "pension_4",
    redirectTo: "/dynamicformdataentry/pension_4",
    pathMatch: "full",
  },
  {
    path: "pension-view/:Id",
    redirectTo: "/dynamicview/pension-view/:Id",
    pathMatch: "full",
  },
  {
    path: "pension-edit/:Id",
    redirectTo: "/dynamicedit/pension-edit/:Id",
    pathMatch: "full",
  },
  {
    path: "pension-back/:Id",
    redirectTo: "/dynamicform/my-assets/:Id",
    pathMatch: "full",
  },

  // ROLES

  {
    path: "roles",
    redirectTo: "/dynamicformdataentry/role_1",
    pathMatch: "full",
  },
  {
    path: "role-new/:newItem",
    redirectTo: "/dynamicgrid/roles-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "role-edit-save/:editItem",
    redirectTo: "/dynamicgrid/roles-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "role-intro",
    redirectTo: "/dynamicformdataentry/role-intro",
    pathMatch: "full",
  },
  {
    path: "role-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/role-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "role_joint-owners",
    redirectTo: "/dynamicformdataentry/role_joint-owners",
    pathMatch: "full",
  },
  {
    path: "role_1",
    redirectTo: "/dynamicformdataentry/role_1",
    pathMatch: "full",
  },
  {
    path: "role_2",
    redirectTo: "/dynamicformdataentry/role_2",
    pathMatch: "full",
  },
  {
    path: "role_3",
    redirectTo: "/dynamicformdataentry/role_3",
    pathMatch: "full",
  },
  {
    path: "role-view/:Id",
    redirectTo: "/dynamicview/role-view/:Id",
    pathMatch: "full",
  },
  {
    path: "role-edit/:Id",
    redirectTo: "/dynamicedit/role-edit/:Id",
    pathMatch: "full",
  },
  {
    path: "role-back/:Id",
    redirectTo: "/dynamicform/my-assets/:Id",
    pathMatch: "full",
  },

  {
    path: "bank-accounts",
    redirectTo: "/dynamicformdataentry/bank-account_1",
    pathMatch: "full",
  },
  {
    path: "bank-account-new/:newItem",
    redirectTo: "/dynamicgrid/bank-accounts-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "bank-account-edit-save/:editItem",
    redirectTo: "/dynamicgrid/bank-accounts-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "bank-account-intro",
    redirectTo: "/dynamicformdataentry/bank-account-intro",
    pathMatch: "full",
  },
  {
    path: "bank-account-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/bank-account-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "bank-account_joint-owners",
    redirectTo: "/dynamicformdataentry/bank-account_joint-owners",
    pathMatch: "full",
  },
  {
    path: "bank-account_1",
    redirectTo: "/dynamicformdataentry/bank-account_1",
    pathMatch: "full",
  },
  {
    path: "bank-account_2",
    redirectTo: "/dynamicformdataentry/bank-account_2",
    pathMatch: "full",
  },
  {
    path: "bank-account_3",
    redirectTo: "/dynamicformdataentry/bank-account_3",
    pathMatch: "full",
  },
  {
    path: "bank-account_4",
    redirectTo: "/dynamicformdataentry/bank-account_4",
    pathMatch: "full",
  },
  {
    path: "bank-account_5",
    redirectTo: "/dynamicformdataentry/bank-account_5",
    pathMatch: "full",
  },
  {
    path: "bank-account_6",
    redirectTo: "/dynamicformdataentry/bank-account_6",
    pathMatch: "full",
  },
  {
    path: "bank-account-view/:Id",
    redirectTo: "/dynamicview/bank-account-view/:Id",
    pathMatch: "full",
  },
  {
    path: "bank-account-edit/:Id",
    redirectTo: "/dynamicedit/bank-account-edit/:Id",
    pathMatch: "full",
  },

  {
    path: "managed-portfolio",
    redirectTo: "/dynamicformdataentry/managed-portfolio_1",
    pathMatch: "full",
  },
  {
    path: "managed-portfolio/:newItem",
    redirectTo: "/dynamicgrid/managed-portfolio-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "managed-portfolio-edit-save/:editItem",
    redirectTo: "/dynamicgrid/managed-portfolio-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "managed-portfolio-intro",
    redirectTo: "/dynamicformdataentry/managed-portfolio-intro",
    pathMatch: "full",
  },
  {
    path: "managed-portfolio-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/managed-portfolio-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "managed-portfolio_joint-owners",
    redirectTo: "/dynamicformdataentry/managed-portfolio_joint-owners",
    pathMatch: "full",
  },
  // {
  //   path: "managed-portfolio_joint-owners-isNFZ",
  //   redirectTo: "/dynamicformdataentry/managed-portfolio_joint-owners?d=nfzRedirection",
  //   pathMatch: "full",
  // },
  {
    path: "managed-portfolio_1",
    redirectTo: "/dynamicformdataentry/managed-portfolio_1",
    pathMatch: "full",
  },
  {
    path: "managed-portfolio_2",
    redirectTo: "/dynamicformdataentry/managed-portfolio_2",
    pathMatch: "full",
  },
  {
    path: "managed-portfolio_3",
    redirectTo: "/dynamicformdataentry/managed-portfolio_3",
    pathMatch: "full",
  },
  {
    path: "managed-portfolio-view/:Id",
    redirectTo: "/dynamicview/managed-portfolio-view/:Id",
    pathMatch: "full",
  },
  {
    path: "managed-portfolio-edit/:Id",
    redirectTo: "/dynamicedit/managed-portfolio-edit/:Id",
    pathMatch: "full",
  },

  // Digital Legacy
  {
    path: "digital-legacy",
    redirectTo: "/dynamicformdataentry/digital-legacy_1",
    pathMatch: "full",
  },
  {
    path: "digital-legacy/:newItem",
    redirectTo: "/dynamicgrid/digital-legacy-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-edit-save/:editItem",
    redirectTo: "/dynamicgrid/digital-legacy-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-intro",
    redirectTo: "/dynamicformdataentry/digital-legacy-intro",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/digital-legacy-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "digital-legacy_1",
    redirectTo: "/dynamicformdataentry/digital-legacy_1",
    pathMatch: "full",
  },
  {
    path: "digital-legacy_joint-owners",
    redirectTo: "/dynamicformdataentry/digital-legacy_joint-owners",
    pathMatch: "full",
  },
  {
    path: "digital-legacy_4",
    redirectTo: "/dynamicformdataentry/digital-legacy_4",
    pathMatch: "full",
  },

  {
    path: "digital-legacy-google_1",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_1",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-apple_1",
    redirectTo: "/dynamicformdataentry/digital-legacy-apple_1",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-facebook_1",
    redirectTo: "/dynamicformdataentry/digital-legacy-facebook_1",
    pathMatch: "full",
  },

  {
    path: "digital-legacy-view/:Id",
    redirectTo: "/dynamicview/digital-legacy-view/:Id",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-edit/:Id",
    redirectTo: "/dynamicedit/digital-legacy-edit/:Id",
    pathMatch: "full",
  },

  // ---- GOOGLE ---- //
  // If client's answer is NO
  {
    path: "digital-legacy-google_2_1",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_2_1",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-google_2_2",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_2_2",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-google_2_3",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_2_3",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-google_2_4",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_2_4",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-google_2_5",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_2_5",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-google_2_6",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_2_6",
    pathMatch: "full",
  },

  // If client's answer is YES
  {
    path: "digital-legacy-google_3_1",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_3_1",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-google_3_2",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_3_2",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-google_3_3",
    redirectTo: "/dynamicformdataentry/digital-legacy-google_3_3",
    pathMatch: "full",
  },

  // ---- APPLE ---- //
  // If client's answer is NO
  {
    path: "digital-legacy-apple_2_1",
    redirectTo: "/dynamicformdataentry/digital-legacy-apple_2_1",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-apple_2_2",
    redirectTo: "/dynamicformdataentry/digital-legacy-apple_2_2",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-apple_2_3",
    redirectTo: "/dynamicformdataentry/digital-legacy-apple_2_3",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-apple_2_4",
    redirectTo: "/dynamicformdataentry/digital-legacy-apple_2_4",
    pathMatch: "full",
  },
  // If client's answer is YES
  {
    path: "digital-legacy-apple_3_1",
    redirectTo: "/dynamicformdataentry/digital-legacy-apple_3_1",
    pathMatch: "full",
  },

  // ---- FACEBOOK ---- //
  // If client's answer is NO
  {
    path: "digital-legacy-facebook_2_1",
    redirectTo: "/dynamicformdataentry/digital-legacy-facebook_2_1",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-facebook_2_2",
    redirectTo: "/dynamicformdataentry/digital-legacy-facebook_2_2",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-facebook_2_3",
    redirectTo: "/dynamicformdataentry/digital-legacy-facebook_2_3",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-facebook_2_4",
    redirectTo: "/dynamicformdataentry/digital-legacy-facebook_2_4",
    pathMatch: "full",
  },
  {
    path: "digital-legacy-facebook_2_5",
    redirectTo: "/dynamicformdataentry/digital-legacy-facebook_2_5",
    pathMatch: "full",
  },

  // If client's answer is YES
  {
    path: "digital-legacy-facebook_3_1",
    redirectTo: "/dynamicformdataentry/digital-legacy-facebook_3_1",
    pathMatch: "full",
  },

  // Important Contacts
  {
    path: "important-contact",
    redirectTo: "/dynamicformdataentry/important-contact_1",
    pathMatch: "full",
  },
  {
    path: "important-contact/:newItem",
    redirectTo: "/dynamicgrid/important-contact/:newItem",
    pathMatch: "full",
  },
  {
    path: "important-contact-edit-save/:editItem",
    redirectTo: "/dynamicgrid/important-contact-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "important-contact-intro",
    redirectTo: "/dynamicformdataentry/important-contact-intro",
    pathMatch: "full",
  },
  {
    path: "important-contact-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/important-contact-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "important-contact_1",
    redirectTo: "/dynamicformdataentry/important-contact_1",
    pathMatch: "full",
  },
  {
    path: "important-contact_2",
    redirectTo: "/dynamicformdataentry/important-contact_2",
    pathMatch: "full",
  },
  {
    path: "important-contact_3",
    redirectTo: "/dynamicformdataentry/important-contact_3",
    pathMatch: "full",
  },
  {
    path: "important-contact-view/:Id",
    redirectTo: "/dynamicview/important-contact-view/:Id",
    pathMatch: "full",
  },
  {
    path: "important-contact-edit/:Id",
    redirectTo: "/dynamicedit/important-contact-edit/:Id",
    pathMatch: "full",
  },

  {
    path: "important-document",
    redirectTo: "/dynamicformdataentry/important-document_1",
    pathMatch: "full",
  },
  {
    path: "important-document/:newItem",
    redirectTo: "/dynamicgrid/important-document/:newItem",
    pathMatch: "full",
  },
  {
    path: "important-document-edit-save/:editItem",
    redirectTo: "/dynamicgrid/important-document-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "important-document-intro",
    redirectTo: "/dynamicformdataentry/important-document-intro",
    pathMatch: "full",
  },
  {
    path: "important-document-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/important-document-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "important-document_1",
    redirectTo: "/dynamicformdataentry/important-document_1",
    pathMatch: "full",
  },
  {
    path: "important-document_2",
    redirectTo: "/dynamicformdataentry/important-document_2",
    pathMatch: "full",
  },
  {
    path: "important-document-view/:Id",
    redirectTo: "/dynamicview/important-document-view/:Id",
    pathMatch: "full",
  },
  {
    path: "important-document-edit/:Id",
    redirectTo: "/dynamicedit/important-document-edit/:Id",
    pathMatch: "full",
  },

  {
    path: "property",
    redirectTo: "/dynamicformdataentry/property_1",
    pathMatch: "full",
  },
  {
    path: "property-new/:newItem",
    redirectTo: "/dynamicgrid/property-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "property-edit-save/:editItem",
    redirectTo: "/dynamicgrid/property-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "property-intro",
    redirectTo: "/dynamicformdataentry/property-intro",
    pathMatch: "full",
  },
  {
    path: "property-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/property-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "property_joint-owners",
    redirectTo: "/dynamicformdataentry/property_joint-owners",
    pathMatch: "full",
  },
  {
    path: "property_1",
    redirectTo: "/dynamicformdataentry/property_1",
    pathMatch: "full",
  },
  {
    path: "property_2",
    redirectTo: "/dynamicformdataentry/property_2",
    pathMatch: "full",
  },
  {
    path: "property_2_1",
    redirectTo: "/dynamicformdataentry/property_2_1",
    pathMatch: "full",
  },
  {
    path: "property_3",
    redirectTo: "/dynamicformdataentry/property_3",
    pathMatch: "full",
  },
  {
    path: "property_4_1",
    redirectTo: "/dynamicformdataentry/property_4_1",
    pathMatch: "full",
  },
  {
    path: "property_4_2",
    redirectTo: "/dynamicformdataentry/property_4_2",
    pathMatch: "full",
  },
  {
    path: "property_4_3",
    redirectTo: "/dynamicformdataentry/property_4_3",
    pathMatch: "full",
  },
  {
    path: "property_4_4",
    redirectTo: "/dynamicformdataentry/property_4_4",
    pathMatch: "full",
  },
  {
    path: "property_6",
    redirectTo: "/dynamicformdataentry/property_6",
    pathMatch: "full",
  },
  {
    path: "property_7",
    redirectTo: "/dynamicformdataentry/property_7",
    pathMatch: "full",
  },
  {
    path: "property_8",
    redirectTo: "/dynamicformdataentry/property_8",
    pathMatch: "full",
  },
  {
    path: "property_9",
    redirectTo: "/dynamicformdataentry/property_9",
    pathMatch: "full",
  },
  {
    path: "property_10",
    redirectTo: "/dynamicformdataentry/property_10",
    pathMatch: "full",
  },
  {
    path: "property-view/:Id",
    redirectTo: "/dynamicview/property-view/:Id",
    pathMatch: "full",
  },
  {
    path: "property-edit/:Id",
    redirectTo: "/dynamicedit/property-edit/:Id",
    pathMatch: "full",
  },

  {
    path: "listed-shares",
    redirectTo: "/dynamicformdataentry/listed-share_1",
    pathMatch: "full",
  },
  {
    path: "listed-share-intro",
    redirectTo: "/dynamicformdataentry/listed-share-intro",
    pathMatch: "full",
  },
  {
    path: "listed-share-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/listed-share-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "listed-share_joint-owners",
    redirectTo: "/dynamicformdataentry/listed-share_joint-owners",
    pathMatch: "full",
  },
  {
    path: "listed-share_1",
    redirectTo: "/dynamicformdataentry/listed-share_1",
    pathMatch: "full",
  },
  {
    path: "listed-share_2",
    redirectTo: "/dynamicformdataentry/listed-share_2",
    pathMatch: "full",
  },
  {
    path: "listed-share_2_2",
    redirectTo: "/dynamicformdataentry/listed-share_2_2",
    pathMatch: "full",
  },
  {
    path: "listed-share_3",
    redirectTo: "/dynamicformdataentry/listed-share_3",
    pathMatch: "full",
  },
  {
    path: "listed-share_4",
    redirectTo: "/dynamicformdataentry/listed-share_4",
    pathMatch: "full",
  },
  {
    path: "listed-share-new/:newItem",
    redirectTo: "/dynamicgrid/listed-shares-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "listed-share-view/:id",
    redirectTo: "/dynamicview/listed-share-view/:id",
    pathMatch: "full",
  },
  {
    path: "listed-share-edit/:id",
    redirectTo: "/dynamicedit/listed-share-edit/:id",
    pathMatch: "full",
  },

  {
    path: "other-assets",
    redirectTo: "/dynamicformdataentry/other-asset_1",
    pathMatch: "full",
  },
  {
    path: "other-asset-new/:newItem",
    redirectTo: "/dynamicgrid/other-assets-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "other-asset-edit-save/:editItem",
    redirectTo: "/dynamicgrid/other-assets-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "other-asset-intro",
    redirectTo: "/dynamicformdataentry/other-asset-intro",
    pathMatch: "full",
  },
  {
    path: "other-asset-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/other-asset-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "other-asset_joint-owners",
    redirectTo: "/dynamicformdataentry/other-asset_joint-owners",
    pathMatch: "full",
  },
  {
    path: "other-asset_1",
    redirectTo: "/dynamicformdataentry/other-asset_1",
    pathMatch: "full",
  },
  {
    path: "other-asset_2",
    redirectTo: "/dynamicformdataentry/other-asset_2",
    pathMatch: "full",
  },
  {
    path: "other-asset_3",
    redirectTo: "/dynamicformdataentry/other-asset_3",
    pathMatch: "full",
  },
  {
    path: "other-asset_4",
    redirectTo: "/dynamicformdataentry/other-asset_4",
    pathMatch: "full",
  },
  {
    path: "other-asset_5",
    redirectTo: "/dynamicformdataentry/other-asset_5",
    pathMatch: "full",
  },
  {
    path: "other-asset_6",
    redirectTo: "/dynamicformdataentry/other-asset_6",
    pathMatch: "full",
  },
  {
    path: "other-asset-view/:Id",
    redirectTo: "/dynamicview/other-asset-view/:Id",
    pathMatch: "full",
  },
  {
    path: "other-asset-edit/:Id",
    redirectTo: "/dynamicedit/other-asset-edit/:Id",
    pathMatch: "full",
  },

  {
    path: "items-of-value",
    redirectTo: "/dynamicformdataentry/item-of-value_1",
    pathMatch: "full",
  },
  {
    path: "item-of-value-intro",
    redirectTo: "/dynamicformdataentry/item-of-value-intro",
    pathMatch: "full",
  },
  {
    path: "item-of-value-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/item-of-value-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "item-of-value_joint-owners",
    redirectTo: "/dynamicformdataentry/item-of-value_joint-owners",
    pathMatch: "full",
  },
  {
    path: "item-of-value_1",
    redirectTo: "/dynamicformdataentry/item-of-value_1",
    pathMatch: "full",
  },
  {
    path: "item-of-value_3",
    redirectTo: "/dynamicformdataentry/item-of-value_3",
    pathMatch: "full",
  },
  {
    path: "item-of-value_2_1",
    redirectTo: "/dynamicformdataentry/item-of-value_2_1",
    pathMatch: "full",
  },
  {
    path: "item-of-value_2_2",
    redirectTo: "/dynamicformdataentry/item-of-value_2_2",
    pathMatch: "full",
  },
  {
    path: "item-of-value_4",
    redirectTo: "/dynamicformdataentry/item-of-value_4",
    pathMatch: "full",
  },
  {
    path: "item-of-value-new/:newItem",
    redirectTo: "/dynamicgrid/items-of-value-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "item-of-value-view/:id",
    redirectTo: "/dynamicview/item-of-value-view/:id",
    pathMatch: "full",
  },
  {
    path: "item-of-value-edit/:Id",
    redirectTo: "/dynamicedit/item-of-value-edit/:Id",
    pathMatch: "full",
  },

  {
    path: "unlisted-shares",
    redirectTo: "/dynamicformdataentry/unlisted-share_1",
    pathMatch: "full",
  },
  {
    path: "unlisted-share-intro",
    redirectTo: "/dynamicformdataentry/unlisted-share-intro",
    pathMatch: "full",
  },
  {
    path: "unlisted-share-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/unlisted-share-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "unlisted-share_joint-owners",
    redirectTo: "/dynamicformdataentry/unlisted-share_joint-owners",
    pathMatch: "full",
  },
  {
    path: "unlisted-share_1",
    redirectTo: "/dynamicformdataentry/unlisted-share_1",
    pathMatch: "full",
  },
  {
    path: "unlisted-share_2",
    redirectTo: "/dynamicformdataentry/unlisted-share_2",
    pathMatch: "full",
  },
  {
    path: "unlisted-share_3",
    redirectTo: "/dynamicformdataentry/unlisted-share_3",
    pathMatch: "full",
  },
  {
    path: "unlisted-share_4",
    redirectTo: "/dynamicformdataentry/unlisted-share_4",
    pathMatch: "full",
  },
  {
    path: "unlisted-share_5",
    redirectTo: "/dynamicformdataentry/unlisted-share_5",
    pathMatch: "full",
  },
  {
    path: "unlisted-share-new/:newItem",
    redirectTo: "/dynamicgrid/unlisted-shares-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "unlisted-share-view/:id",
    redirectTo: "/dynamicview/unlisted-share-view/:id",
    pathMatch: "full",
  },
  {
    path: "unlisted-share-edit/:id",
    redirectTo: "/dynamicedit/unlisted-share-edit/:id",
    pathMatch: "full",
  },
  {
    path: "unlisted-share-edit-save/:editItem",
    redirectTo: "/dynamicgrid/unlisted-share-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "financial-products",
    redirectTo: "/dynamicformdataentry/financial-product_1",
    pathMatch: "full",
  },
  {
    path: "financial-product-new/:newItem",
    redirectTo: "/dynamicgrid/financial-products-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "financial-product-edit-save/:editItem",
    redirectTo: "/dynamicgrid/financial-products-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "financial-product-intro",
    redirectTo: "/dynamicformdataentry/financial-product-intro",
    pathMatch: "full",
  },
  {
    path: "financial-product-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/financial-product-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "financial-product_joint-owners",
    redirectTo: "/dynamicformdataentry/financial-product_joint-owners",
    pathMatch: "full",
  },
  {
    path: "financial-product_1",
    redirectTo: "/dynamicformdataentry/financial-product_1",
    pathMatch: "full",
  },
  {
    path: "financial-product_2",
    redirectTo: "/dynamicformdataentry/financial-product_2",
    pathMatch: "full",
  },
  {
    path: "financial-product_3",
    redirectTo: "/dynamicformdataentry/financial-product_3",
    pathMatch: "full",
  },
  {
    path: "financial-product_4",
    redirectTo: "/dynamicformdataentry/financial-product_4",
    pathMatch: "full",
  },
  {
    path: "financial-product_4_1",
    redirectTo: "/dynamicformdataentry/financial-product_4_1",
    pathMatch: "full",
  },
  {
    path: "financial-product_4_2",
    redirectTo: "/dynamicformdataentry/financial-product_4_2",
    pathMatch: "full",
  },
  {
    path: "financial-product_5",
    redirectTo: "/dynamicformdataentry/financial-product_5",
    pathMatch: "full",
  },
  {
    path: "financial-product-view/:Id",
    redirectTo: "/dynamicview/financial-product-view/:Id",
    pathMatch: "full",
  },
  {
    path: "financial-product-edit/:Id",
    redirectTo: "/dynamicedit/financial-product-edit/:Id",
    pathMatch: "full",
  },

  {
    path: "money-owed-to-me",
    redirectTo: "/dynamicformdataentry/money-owed-to-me_1",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me-new/:newItem",
    redirectTo: "/dynamicgrid/money-owed-to-me-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me-edit-save/:editItem",
    redirectTo: "/dynamicgrid/money-owed-to-me-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me-intro",
    redirectTo: "/dynamicformdataentry/money-owed-to-me-intro",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/money-owed-to-me-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me_joint-owners",
    redirectTo: "/dynamicformdataentry/money-owed-to-me_joint-owners",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me_1",
    redirectTo: "/dynamicformdataentry/money-owed-to-me_1",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me_2",
    redirectTo: "/dynamicformdataentry/money-owed-to-me_2",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me_3",
    redirectTo: "/dynamicformdataentry/money-owed-to-me_3",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me_4",
    redirectTo: "/dynamicformdataentry/money-owed-to-me_4",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me_5",
    redirectTo: "/dynamicformdataentry/money-owed-to-me_5",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me-view/:Id",
    redirectTo: "/dynamicview/money-owed-to-me-view/:Id",
    pathMatch: "full",
  },
  {
    path: "money-owed-to-me-edit/:Id",
    redirectTo: "/dynamicedit/money-owed-to-me-edit/:Id",
    pathMatch: "full",
  },

  {
    path: "national-savings-and-investment",
    redirectTo: "/dynamicformdataentry/national-savings-and-investment_1",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment-new/:newItem",
    redirectTo: "/dynamicgrid/national-savings-and-investment-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment-edit-save/:editItem",
    redirectTo: "/dynamicgrid/national-savings-and-investment-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment-intro",
    redirectTo: "/dynamicformdataentry/national-savings-and-investment-intro",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/national-savings-and-investment-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment_joint-owners",
    redirectTo:
      "/dynamicformdataentry/national-savings-and-investment_joint-owners",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment_1",
    redirectTo: "/dynamicformdataentry/national-savings-and-investment_1",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment_2",
    redirectTo: "/dynamicformdataentry/national-savings-and-investment_2",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment_2_2",
    redirectTo: "/dynamicformdataentry/national-savings-and-investment_2_2",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment_3",
    redirectTo: "/dynamicformdataentry/national-savings-and-investment_3",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment_4",
    redirectTo: "/dynamicformdataentry/national-savings-and-investment_4",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment_5",
    redirectTo: "/dynamicformdataentry/national-savings-and-investment_5",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment-view/:Id",
    redirectTo: "/dynamicview/national-savings-and-investment-view/:Id",
    pathMatch: "full",
  },
  {
    path: "national-savings-and-investment-edit/:Id",
    redirectTo: "/dynamicedit/national-savings-and-investment-edit/:Id",
    pathMatch: "full",
  },

  // Debts
  {
    path: "mortgages",
    redirectTo: "/dynamicformdataentry/mortgage_1",
    pathMatch: "full",
  },
  {
    path: "mortgage-intro",
    redirectTo: "/dynamicformdataentry/mortgage-intro",
    pathMatch: "full",
  },
  {
    path: "mortgage-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/mortgage-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "mortgage_joint-owners",
    redirectTo: "/dynamicformdataentry/mortgage_joint-owners",
    pathMatch: "full",
  },
  {
    path: "mortgage_1",
    redirectTo: "/dynamicformdataentry/mortgage_1",
    pathMatch: "full",
  },
  {
    path: "mortgage_2",
    redirectTo: "/dynamicformdataentry/mortgage_2",
    pathMatch: "full",
  },
  {
    path: "mortgage_4",
    redirectTo: "/dynamicformdataentry/mortgage_4",
    pathMatch: "full",
  },
  {
    path: "mortgage_5",
    redirectTo: "/dynamicformdataentry/mortgage_5",
    pathMatch: "full",
  },
  {
    path: "mortgage_5_1",
    redirectTo: "/dynamicformdataentry/mortgage_5_1",
    pathMatch: "full",
  },
  {
    path: "mortgage_6",
    redirectTo: "/dynamicformdataentry/mortgage_5",
    pathMatch: "full",
  },
  {
    path: "mortgage-new/:newItem",
    redirectTo: "/dynamicgrid/mortgages-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "mortgage-view/:id",
    redirectTo: "/dynamicview/mortgage-view/:id",
    pathMatch: "full",
  },
  {
    path: "mortgage-edit/:id",
    redirectTo: "/dynamicedit/mortgage-edit/:id",
    pathMatch: "full",
  },
  {
    path: "mortgage-edit-save/:editItem",
    redirectTo: "/dynamicgrid/mortgages-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "credit-cards",
    redirectTo: "/dynamicformdataentry/credit-card_1",
    pathMatch: "full",
  },
  {
    path: "credit-card-intro",
    redirectTo: "/dynamicformdataentry/credit-card-intro",
    pathMatch: "full",
  },
  {
    path: "credit-card-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/credit-card-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "credit-card_joint-owners",
    redirectTo: "/dynamicformdataentry/credit-card_joint-owners",
    pathMatch: "full",
  },
  {
    path: "credit-card_1",
    redirectTo: "/dynamicformdataentry/credit-card_1",
    pathMatch: "full",
  },
  {
    path: "credit-card_2",
    redirectTo: "/dynamicformdataentry/credit-card_2",
    pathMatch: "full",
  },
  {
    path: "credit-card_3",
    redirectTo: "/dynamicformdataentry/credit-card_3",
    pathMatch: "full",
  },
  {
    path: "credit-card-new/:newItem",
    redirectTo: "/dynamicgrid/credit-cards-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "credit-card-view/:id",
    redirectTo: "/dynamicview/credit-card-view/:id",
    pathMatch: "full",
  },
  {
    path: "credit-card-edit/:id",
    redirectTo: "/dynamicedit/credit-card-edit/:id",
    pathMatch: "full",
  },
  {
    path: "credit-card-edit-save/:editItem",
    redirectTo: "/dynamicgrid/credit-card-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "tax-debts",
    redirectTo: "/dynamicformdataentry/tax-debt_1",
    pathMatch: "full",
  },
  {
    path: "tax-debt-intro",
    redirectTo: "/dynamicformdataentry/tax-debt-intro",
    pathMatch: "full",
  },
  {
    path: "tax-debt-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/tax-debt-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "tax-debt_joint-owners",
    redirectTo: "/dynamicformdataentry/tax-debt_joint-owners",
    pathMatch: "full",
  },
  {
    path: "tax-debt_1",
    redirectTo: "/dynamicformdataentry/tax-debt_1",
    pathMatch: "full",
  },
  {
    path: "tax-debt_2",
    redirectTo: "/dynamicformdataentry/tax-debt_2",
    pathMatch: "full",
  },
  {
    path: "tax-debt-new/:newItem",
    redirectTo: "/dynamicgrid/tax-debts-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "tax-debt-view/:id",
    redirectTo: "/dynamicview/tax-debt-view/:id",
    pathMatch: "full",
  },
  {
    path: "tax-debt-edit/:id",
    redirectTo: "/dynamicedit/tax-debt-edit/:id",
    pathMatch: "full",
  },
  {
    path: "tax-debt-edit-save/:editItem",
    redirectTo: "/dynamicgrid/tax-debt-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "leased-items",
    redirectTo: "/dynamicformdataentry/leased-item_1",
    pathMatch: "full",
  },
  {
    path: "leased-item-intro",
    redirectTo: "/dynamicformdataentry/leased-item-intro",
    pathMatch: "full",
  },
  {
    path: "leased-item-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/leased-item-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "leased-item_joint-owners",
    redirectTo: "/dynamicformdataentry/leased-item_joint-owners",
    pathMatch: "full",
  },
  {
    path: "leased-item_1",
    redirectTo: "/dynamicformdataentry/leased-item_1",
    pathMatch: "full",
  },
  {
    path: "leased-item_2_1",
    redirectTo: "/dynamicformdataentry/leased-item_2_1",
    pathMatch: "full",
  },
  {
    path: "leased-item_2_2",
    redirectTo: "/dynamicformdataentry/leased-item_2_2",
    pathMatch: "full",
  },
  {
    path: "leased-item_3",
    redirectTo: "/dynamicformdataentry/leased-item_3",
    pathMatch: "full",
  },
  {
    path: "leased-item_4",
    redirectTo: "/dynamicformdataentry/leased-item_4",
    pathMatch: "full",
  },
  {
    path: "leased-item-new/:newItem",
    redirectTo: "/dynamicgrid/leased-items-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "leased-item-view/:id",
    redirectTo: "/dynamicview/leased-item-view/:id",
    pathMatch: "full",
  },
  {
    path: "leased-item-edit/:id",
    redirectTo: "/dynamicedit/leased-item-edit/:id",
    pathMatch: "full",
  },
  {
    path: "leased-item-edit-save/:editItem",
    redirectTo: "/dynamicgrid/leased-item-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "loans",
    redirectTo: "/dynamicformdataentry/loan_1",
    pathMatch: "full",
  },
  {
    path: "loan-new/:newItem",
    redirectTo: "/dynamicgrid/loan-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "loan-edit-save/:editItem",
    redirectTo: "/dynamicgrid/loan-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "loan-intro",
    redirectTo: "/dynamicformdataentry/loan-intro",
    pathMatch: "full",
  },
  {
    path: "loan-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/loan-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "loan_joint-owners",
    redirectTo: "/dynamicformdataentry/loan_joint-owners",
    pathMatch: "full",
  },
  {
    path: "loan_1",
    redirectTo: "/dynamicformdataentry/loan_1",
    pathMatch: "full",
  },
  {
    path: "loan_2",
    redirectTo: "/dynamicformdataentry/loan_2",
    pathMatch: "full",
  },
  {
    path: "loan_3",
    redirectTo: "/dynamicformdataentry/loan_3",
    pathMatch: "full",
  },
  {
    path: "loan_4",
    redirectTo: "/dynamicformdataentry/loan_4",
    pathMatch: "full",
  },
  {
    path: "loan_5",
    redirectTo: "/dynamicformdataentry/loan_5",
    pathMatch: "full",
  },
  {
    path: "loan_6",
    redirectTo: "/dynamicformdataentry/loan_6",
    pathMatch: "full",
  },
  {
    path: "loan-view/:Id",
    redirectTo: "/dynamicview/loan-view/:Id",
    pathMatch: "full",
  },
  {
    path: "loan-edit/:Id",
    redirectTo: "/dynamicedit/loan-edit/:Id",
    pathMatch: "full",
  },

  // Daily Life

  {
    path: "utilities",
    redirectTo: "/dynamicformdataentry/utility_1",
    pathMatch: "full",
  },
  {
    path: "utility-new/:newItem",
    redirectTo: "/dynamicgrid/utility-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "utility-edit-save/:editItem",
    redirectTo: "/dynamicgrid/utility-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "utility-intro",
    redirectTo: "/dynamicformdataentry/utility-intro",
    pathMatch: "full",
  },
  {
    path: "utility-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/utility-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "utility_1",
    redirectTo: "/dynamicformdataentry/utility_1",
    pathMatch: "full",
  },
  {
    path: "utility_2",
    redirectTo: "/dynamicformdataentry/utility_2",
    pathMatch: "full",
  },
  {
    path: "utility_2_1",
    redirectTo: "/dynamicformdataentry/utility_2_1",
    pathMatch: "full",
  },
  {
    path: "utility_2_2",
    redirectTo: "/dynamicformdataentry/utility_2_2",
    pathMatch: "full",
  },
  {
    path: "utility_2_3",
    redirectTo: "/dynamicformdataentry/utility_2_3",
    pathMatch: "full",
  },
  {
    path: "utility_2_4",
    redirectTo: "/dynamicformdataentry/utility_2_4",
    pathMatch: "full",
  },
  {
    path: "utility_2_5",
    redirectTo: "/dynamicformdataentry/utility_2_5",
    pathMatch: "full",
  },
  {
    path: "utility_2_6",
    redirectTo: "/dynamicformdataentry/utility_2_6",
    pathMatch: "full",
  },
  {
    path: "utility_2_7",
    redirectTo: "/dynamicformdataentry/utility_2_7",
    pathMatch: "full",
  },
  {
    path: "utility_2_8",
    redirectTo: "/dynamicformdataentry/utility_2_8",
    pathMatch: "full",
  },
  {
    path: "utility_2_9",
    redirectTo: "/dynamicformdataentry/utility_2_9",
    pathMatch: "full",
  },
  {
    path: "utility_3",
    redirectTo: "/dynamicformdataentry/utility_3",
    pathMatch: "full",
  },
  {
    path: "utility_4",
    redirectTo: "/dynamicformdataentry/utility_4",
    pathMatch: "full",
  },
  {
    path: "utility-view/:Id",
    redirectTo: "/dynamicview/utility-view/:Id",
    pathMatch: "full",
  },
  {
    path: "utility-edit/:Id",
    redirectTo: "/dynamicedit/utility-edit/:Id",
    pathMatch: "full",
  },

  {
    path: "insurance",
    redirectTo: "/dynamicformdataentry/insurance_1",
    pathMatch: "full",
  },
  {
    path: "insurance-intro",
    redirectTo: "/dynamicformdataentry/insurance-intro",
    pathMatch: "full",
  },
  {
    path: "insurance-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/insurance-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "insurance_1",
    redirectTo: "/dynamicformdataentry/insurance_1",
    pathMatch: "full",
  },
  {
    path: "insurance_2_1",
    redirectTo: "/dynamicformdataentry/insurance_2_1",
    pathMatch: "full",
  },
  {
    path: "insurance_2_2",
    redirectTo: "/dynamicformdataentry/insurance_2_2",
    pathMatch: "full",
  },
  {
    path: "insurance_2_3",
    redirectTo: "/dynamicformdataentry/insurance_2_3",
    pathMatch: "full",
  },
  {
    path: "insurance_2_4",
    redirectTo: "/dynamicformdataentry/insurance_2_4",
    pathMatch: "full",
  },
  {
    path: "insurance_2_5",
    redirectTo: "/dynamicformdataentry/insurance_2_5",
    pathMatch: "full",
  },
  {
    path: "insurance_2_6",
    redirectTo: "/dynamicformdataentry/insurance_2_6",
    pathMatch: "full",
  },
  {
    path: "insurance_3",
    redirectTo: "/dynamicformdataentry/insurance_3",
    pathMatch: "full",
  },
  {
    path: "insurance_4",
    redirectTo: "/dynamicformdataentry/insurance_4",
    pathMatch: "full",
  },
  {
    path: "insurance-new/:newItem",
    redirectTo: "/dynamicgrid/insurances-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "insurance-view/:id",
    redirectTo: "/dynamicview/insurance-view/:id",
    pathMatch: "full",
  },
  {
    path: "insurance-edit/:id",
    redirectTo: "/dynamicedit/insurance-edit/:id",
    pathMatch: "full",
  },
  {
    path: "insurance-edit-save/:editItem",
    redirectTo: "/dynamicgrid/insurance-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "documents",
    redirectTo: "/dynamicformdataentry/document_1",
    pathMatch: "full",
  },
  {
    path: "document-intro",
    redirectTo: "/dynamicformdataentry/document-intro",
    pathMatch: "full",
  },
  {
    path: "document-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/document-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "document_1",
    redirectTo: "/dynamicformdataentry/document_1",
    pathMatch: "full",
  },
  {
    path: "document_2",
    redirectTo: "/dynamicformdataentry/document_2",
    pathMatch: "full",
  },
  {
    path: "document-new/:newItem",
    redirectTo: "/dynamicgrid/documents-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "document-view/:id",
    redirectTo: "/dynamicview/document-view/:id",
    pathMatch: "full",
  },
  {
    path: "document-edit/:id",
    redirectTo: "/dynamicedit/document-edit/:id",
    pathMatch: "full",
  },
  {
    path: "document-edit-save/:editItem",
    redirectTo: "/dynamicgrid/documents-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "pets",
    redirectTo: "/dynamicformdataentry/pet_1",
    pathMatch: "full",
  },
  {
    path: "pet-intro",
    redirectTo: "/dynamicformdataentry/pet-intro",
    pathMatch: "full",
  },
  {
    path: "pet-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/pet-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "pet_1",
    redirectTo: "/dynamicformdataentry/pet_1",
    pathMatch: "full",
  },
  {
    path: "pet_2",
    redirectTo: "/dynamicformdataentry/pet_2",
    pathMatch: "full",
  },
  {
    path: "pet_3",
    redirectTo: "/dynamicformdataentry/pet_3",
    pathMatch: "full",
  },
  {
    path: "pet_4",
    redirectTo: "/dynamicformdataentry/pet_4",
    pathMatch: "full",
  },
  {
    path: "pet_5",
    redirectTo: "/dynamicformdataentry/pet_5",
    pathMatch: "full",
  },
  {
    path: "pet_6",
    redirectTo: "/dynamicformdataentry/pet_6",
    pathMatch: "full",
  },
  {
    path: "pet-new/:newItem",
    redirectTo: "/dynamicgrid/pets-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "pet-view/:id",
    redirectTo: "/dynamicview/pet-view/:id",
    pathMatch: "full",
  },
  {
    path: "pet-edit/:id",
    redirectTo: "/dynamicedit/pet-edit/:id",
    pathMatch: "full",
  },
  {
    path: "pet-edit-save/:editItem",
    redirectTo: "/dynamicgrid/pets-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "rents",
    redirectTo: "/dynamicformdataentry/rent_1",
    pathMatch: "full",
  },
  {
    path: "rent",
    redirectTo: "/dynamicformdataentry/rent_1",
    pathMatch: "full",
  },
  {
    path: "rent-intro",
    redirectTo: "/dynamicformdataentry/rent-intro",
    pathMatch: "full",
  },
  {
    path: "rent-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/rent-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "rent_1",
    redirectTo: "/dynamicformdataentry/rent_1",
    pathMatch: "full",
  },
  {
    path: "rent_2",
    redirectTo: "/dynamicformdataentry/rent_2",
    pathMatch: "full",
  },
  {
    path: "rent_3_1",
    redirectTo: "/dynamicformdataentry/rent_3_1",
    pathMatch: "full",
  },
  {
    path: "rent_3_2",
    redirectTo: "/dynamicformdataentry/rent_3_2",
    pathMatch: "full",
  },
  {
    path: "rent_4",
    redirectTo: "/dynamicformdataentry/rent_4",
    pathMatch: "full",
  },
  {
    path: "rent_5",
    redirectTo: "/dynamicformdataentry/rent_5",
    pathMatch: "full",
  },
  {
    path: "rent_6",
    redirectTo: "/dynamicformdataentry/rent_6",
    pathMatch: "full",
  },
  {
    path: "rent-new/:newItem",
    redirectTo: "/dynamicgrid/rents-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "rent-view/:id",
    redirectTo: "/dynamicview/rent-view/:id",
    pathMatch: "full",
  },
  {
    path: "rent-edit/:id",
    redirectTo: "/dynamicedit/rent-edit/:id",
    pathMatch: "full",
  },
  {
    path: "rent-edit-save/:editItem",
    redirectTo: "/dynamicgrid/rents-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "trust",
    redirectTo: "/dynamicformdataentry/trust_1",
    pathMatch: "full",
  },
  {
    path: "trust",
    redirectTo: "/dynamicformdataentry/trust_1",
    pathMatch: "full",
  },
  {
    path: "trust-intro",
    redirectTo: "/dynamicformdataentry/trust-intro",
    pathMatch: "full",
  },
  {
    path: "trust-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/trust-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "trust_joint-owners",
    redirectTo: "/dynamicformdataentry/trust_joint-owners",
    pathMatch: "full",
  },

  {
    path: "trust_1",
    redirectTo: "/dynamicformdataentry/trust_1",
    pathMatch: "full",
  },
  {
    path: "trust_7",
    redirectTo: "/dynamicformdataentry/trust_7",
    pathMatch: "full",
  },

  {
    path: "trust_beneficiary_1",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_1",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_2_1",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_2_1",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_2_2",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_2_2",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_3",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_3",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_4_1",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_4_1",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_4_2",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_4_2",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_5",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_5",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_6_1",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_6_1",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_6_2",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_6_2",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_6_3",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_6_3",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_6_4",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_6_4",
    pathMatch: "full",
  },
  {
    path: "trust_beneficiary_6_5",
    redirectTo: "/dynamicformdataentry/trust_beneficiary_6_5",
    pathMatch: "full",
  },

  {
    path: "trust_settelor_1",
    redirectTo: "/dynamicformdataentry/trust_settelor_1",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_2_1",
    redirectTo: "/dynamicformdataentry/trust_settelor_2_1",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_2_2",
    redirectTo: "/dynamicformdataentry/trust_settelor_2_2",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_3",
    redirectTo: "/dynamicformdataentry/trust_settelor_3",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_4_1",
    redirectTo: "/dynamicformdataentry/trust_settelor_4_1",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_4_2",
    redirectTo: "/dynamicformdataentry/trust_settelor_4_2",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_4_3",
    redirectTo: "/dynamicformdataentry/trust_settelor_4_3",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_5",
    redirectTo: "/dynamicformdataentry/trust_settelor_5",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_6_1",
    redirectTo: "/dynamicformdataentry/trust_settelor_6_1",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_6_2",
    redirectTo: "/dynamicformdataentry/trust_settelor_6_2",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_6_3",
    redirectTo: "/dynamicformdataentry/trust_settelor_6_3",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_6_4",
    redirectTo: "/dynamicformdataentry/trust_settelor_6_4",
    pathMatch: "full",
  },
  {
    path: "trust_settelor_6_5",
    redirectTo: "/dynamicformdataentry/trust_settelor_6_5",
    pathMatch: "full",
  },

  {
    path: "trust-view/:id",
    redirectTo: "/dynamicview/trust-view/:id",
    pathMatch: "full",
  },
  {
    path: "trust-edit/:id",
    redirectTo: "/dynamicedit/trust-edit/:id",
    pathMatch: "full",
  },
  {
    path: "trust-edit-save/:editItem",
    redirectTo: "/dynamicgrid/trust-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "life-time-gifts",
    redirectTo: "/dynamicformdataentry/life-time-gift_1",
    pathMatch: "full",
  },
  {
    path: "life-time-gift-intro",
    redirectTo: "/dynamicformdataentry/life-time-gift-intro",
    pathMatch: "full",
  },
  {
    path: "life-time-gift-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/life-time-gift-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "life-time-gift_1",
    redirectTo: "/dynamicformdataentry/life-time-gift_1",
    pathMatch: "full",
  },
  {
    path: "life-time-gift_2",
    redirectTo: "/dynamicformdataentry/life-time-gift_2",
    pathMatch: "full",
  },
  {
    path: "life-time-gift_3",
    redirectTo: "/dynamicformdataentry/life-time-gift_3",
    pathMatch: "full",
  },
  {
    path: "life-time-gift-new/:newItem",
    redirectTo: "/dynamicgrid/life-time-gifts-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "life-time-gift-view/:id",
    redirectTo: "/dynamicview/life-time-gift-view/:id",
    pathMatch: "full",
  },
  {
    path: "life-time-gift-edit/:id",
    redirectTo: "/dynamicedit/life-time-gift-edit/:id",
    pathMatch: "full",
  },
  {
    path: "life-time-gift-edit-save/:editItem",
    redirectTo: "/dynamicgrid/life-time-gift-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "online-accounts",
    redirectTo: "/dynamicformdataentry/online-account_1",
    pathMatch: "full",
  },
  {
    path: "online-account-intro",
    redirectTo: "/dynamicformdataentry/online-account-intro",
    pathMatch: "full",
  },
  {
    path: "online-account-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/online-account-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "online-account_1",
    redirectTo: "/dynamicformdataentry/online-account_1",
    pathMatch: "full",
  },
  {
    path: "online-account_2_1",
    redirectTo: "/dynamicformdataentry/online-account_2_1",
    pathMatch: "full",
  },
  {
    path: "online-account_2_2",
    redirectTo: "/dynamicformdataentry/online-account_2_2",
    pathMatch: "full",
  },
  {
    path: "online-account_2_3",
    redirectTo: "/dynamicformdataentry/online-account_2_3",
    pathMatch: "full",
  },
  {
    path: "online-account_3",
    redirectTo: "/dynamicformdataentry/online-account_3",
    pathMatch: "full",
  },
  {
    path: "online-account-new/:newItem",
    redirectTo: "/dynamicgrid/online-accounts-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "online-account-view/:id",
    redirectTo: "/dynamicview/online-account-view/:id",
    pathMatch: "full",
  },
  {
    path: "online-account-edit/:id",
    redirectTo: "/dynamicedit/online-account-edit/:id",
    pathMatch: "full",
  },
  {
    path: "online-account-edit-save/:editItem",
    redirectTo: "/dynamicgrid/online-account-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "memberships",
    redirectTo: "/dynamicformdataentry/membership_1",
    pathMatch: "full",
  },
  {
    path: "membership-intro",
    redirectTo: "/dynamicformdataentry/membership-intro",
    pathMatch: "full",
  },
  {
    path: "membership-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/membership-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "membership_1",
    redirectTo: "/dynamicformdataentry/membership_1",
    pathMatch: "full",
  },
  {
    path: "membership_2",
    redirectTo: "/dynamicformdataentry/membership_2",
    pathMatch: "full",
  },
  {
    path: "membership_3",
    redirectTo: "/dynamicformdataentry/membership_3",
    pathMatch: "full",
  },
  {
    path: "membership_4",
    redirectTo: "/dynamicformdataentry/membership_4",
    pathMatch: "full",
  },
  {
    path: "membership_5",
    redirectTo: "/dynamicformdataentry/membership_5",
    pathMatch: "full",
  },
  {
    path: "membership_6",
    redirectTo: "/dynamicformdataentry/membership_6",
    pathMatch: "full",
  },
  {
    path: "membership-new/:newItem",
    redirectTo: "/dynamicgrid/memberships-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "membership-view/:id",
    redirectTo: "/dynamicview/membership-view/:id",
    pathMatch: "full",
  },
  {
    path: "membership-edit/:id",
    redirectTo: "/dynamicedit/membership-edit/:id",
    pathMatch: "full",
  },
  {
    path: "membership-edit-save/:editItem",
    redirectTo: "/dynamicgrid/memberships-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "work",
    redirectTo: "/dynamicformdataentry/work_1",
    pathMatch: "full",
  },
  {
    path: "work_joint-owners",
    redirectTo: "/dynamicformdataentry/work_joint-owners",
    pathMatch: "full",
  },
  {
    path: "work-intro",
    redirectTo: "/dynamicformdataentry/work-intro",
    pathMatch: "full",
  },
  {
    path: "work-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/work-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "work_1",
    redirectTo: "/dynamicformdataentry/work_1",
    pathMatch: "full",
  },
  {
    path: "work_2_1",
    redirectTo: "/dynamicformdataentry/work_2_1",
    pathMatch: "full",
  },
  {
    path: "work_2_2",
    redirectTo: "/dynamicformdataentry/work_2_2",
    pathMatch: "full",
  },
  {
    path: "work_3_1",
    redirectTo: "/dynamicformdataentry/work_3_1",
    pathMatch: "full",
  },
  {
    path: "work_4_1",
    redirectTo: "/dynamicformdataentry/work_4_1",
    pathMatch: "full",
  },
  {
    path: "work_4_2",
    redirectTo: "/dynamicformdataentry/work_4_2",
    pathMatch: "full",
  },
  {
    path: "work_5_1",
    redirectTo: "/dynamicformdataentry/work_5_1",
    pathMatch: "full",
  },
  {
    path: "work_5_2",
    redirectTo: "/dynamicformdataentry/work_5_2",
    pathMatch: "full",
  },
  {
    path: "work_6",
    redirectTo: "/dynamicformdataentry/work_6",
    pathMatch: "full",
  },
  {
    path: "work-new/:newItem",
    redirectTo: "/dynamicgrid/works-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "work-view/:id",
    redirectTo: "/dynamicview/work-view/:id",
    pathMatch: "full",
  },
  {
    path: "work-edit/:id",
    redirectTo: "/dynamicedit/work-edit/:id",
    pathMatch: "full",
  },
  {
    path: "work-edit-save/:editItem",
    redirectTo: "/dynamicgrid/work-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "healthcare",
    redirectTo: "/dynamicformdataentry/healthcare_1",
    pathMatch: "full",
  },
  {
    path: "healthcare-intro",
    redirectTo: "/dynamicformdataentry/healthcare-intro",
    pathMatch: "full",
  },
  {
    path: "healthcare-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/healthcare-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "healthcare_1",
    redirectTo: "/dynamicformdataentry/healthcare_1",
    pathMatch: "full",
  },
  {
    path: "healthcare_2",
    redirectTo: "/dynamicformdataentry/healthcare_2",
    pathMatch: "full",
  },
  {
    path: "healthcare_3",
    redirectTo: "/dynamicformdataentry/healthcare_3",
    pathMatch: "full",
  },
  {
    path: "healthcare-new/:newItem",
    redirectTo: "/dynamicgrid/healthcares-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "healthcare-view/:id",
    redirectTo: "/dynamicview/healthcare-view/:id",
    pathMatch: "full",
  },
  {
    path: "healthcare-edit/:id",
    redirectTo: "/dynamicedit/healthcare-edit/:id",
    pathMatch: "full",
  },
  {
    path: "healthcare-edit-save/:editItem",
    redirectTo: "/dynamicgrid/healthcare-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "medications",
    redirectTo: "/dynamicformdataentry/medication_1",
    pathMatch: "full",
  },
  {
    path: "medication-intro",
    redirectTo: "/dynamicformdataentry/medication-intro",
    pathMatch: "full",
  },
  {
    path: "medication-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/medication-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "medication_1",
    redirectTo: "/dynamicformdataentry/medication_1",
    pathMatch: "full",
  },
  {
    path: "medication_2",
    redirectTo: "/dynamicformdataentry/medication_2",
    pathMatch: "full",
  },
  {
    path: "medication_3",
    redirectTo: "/dynamicformdataentry/medication_3",
    pathMatch: "full",
  },
  {
    path: "medication-new/:newItem",
    redirectTo: "/dynamicgrid/medications-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "medication-view/:id",
    redirectTo: "/dynamicview/medication-view/:id",
    pathMatch: "full",
  },
  {
    path: "medication-edit/:id",
    redirectTo: "/dynamicedit/medication-edit/:id",
    pathMatch: "full",
  },
  {
    path: "medication-edit-save/:editItem",
    redirectTo: "/dynamicgrid/medications-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "general-expenses",
    redirectTo: "/dynamicformdataentry/general-expense_1",
    pathMatch: "full",
  },
  {
    path: "general-expense-intro",
    redirectTo: "/dynamicformdataentry/general-expense-intro",
    pathMatch: "full",
  },
  {
    path: "general-expense-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/general-expense-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "general-expense_1",
    redirectTo: "/dynamicformdataentry/general-expense_1",
    pathMatch: "full",
  },
  {
    path: "general-expense_2",
    redirectTo: "/dynamicformdataentry/general-expense_2",
    pathMatch: "full",
  },
  {
    path: "general-expense_3",
    redirectTo: "/dynamicformdataentry/general-expense_3",
    pathMatch: "full",
  },
  {
    path: "general-expense_4",
    redirectTo: "/dynamicformdataentry/general-expense_4",
    pathMatch: "full",
  },
  {
    path: "general-expense-new/:newItem",
    redirectTo: "/dynamicgrid/general-expenses-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "general-expense-view/:id",
    redirectTo: "/dynamicview/general-expense-view/:id",
    pathMatch: "full",
  },
  {
    path: "general-expense-edit/:id",
    redirectTo: "/dynamicedit/general-expense-edit/:id",
    pathMatch: "full",
  },
  {
    path: "general-expense-edit-save/:editItem",
    redirectTo: "/dynamicgrid/general-expenses-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "others",
    redirectTo: "/dynamicformdataentry/other_1",
    pathMatch: "full",
  },
  {
    path: "other-intro",
    redirectTo: "/dynamicformdataentry/other-intro",
    pathMatch: "full",
  },
  {
    path: "other-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/other-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "other_1",
    redirectTo: "/dynamicformdataentry/other_1",
    pathMatch: "full",
  },
  {
    path: "other-new/:newItem",
    redirectTo: "/dynamicgrid/others-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "other-view/:id",
    redirectTo: "/dynamicview/other-view/:id",
    pathMatch: "full",
  },
  {
    path: "other-edit/:id",
    redirectTo: "/dynamicedit/other-edit/:id",
    pathMatch: "full",
  },
  {
    path: "other-edit-save/:editItem",
    redirectTo: "/dynamicgrid/others-grid/:editItem",
    pathMatch: "full",
  },

  // Wishes

  {
    path: "wills",
    redirectTo: "/dynamicformdataentry/will_1",
    pathMatch: "full",
  },
  {
    path: "will",
    redirectTo: "/dynamicformdataentry/will_1",
    pathMatch: "full",
  },
  {
    path: "will-intro",
    redirectTo: "/dynamicformdataentry/will-intro",
    pathMatch: "full",
  },
  {
    path: "will-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/will-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "will_1",
    redirectTo: "/dynamicformdataentry/will_1",
    pathMatch: "full",
  },
  {
    path: "will_2",
    redirectTo: "/dynamicformdataentry/will_2",
    pathMatch: "full",
  },
  {
    path: "will-new/:newItem",
    redirectTo: "/dynamicgrid/wills-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "will-view/:id",
    redirectTo: "/dynamicview/will-view/:id",
    pathMatch: "full",
  },
  {
    path: "will-edit/:id",
    redirectTo: "/dynamicedit/will-edit/:id",
    pathMatch: "full",
  },
  {
    path: "will-edit-save/:editItem",
    redirectTo: "/dynamicgrid/will-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "power-of-attorney",
    redirectTo: "/dynamicformdataentry/power-of-attorney_1",
    pathMatch: "full",
  },
  {
    path: "power-of-attorney-intro",
    redirectTo: "/dynamicformdataentry/power-of-attorney-intro",
    pathMatch: "full",
  },
  {
    path: "power-of-attorney-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/power-of-attorney-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "power-of-attorney_1",
    redirectTo: "/dynamicformdataentry/power-of-attorney_1",
    pathMatch: "full",
  },
  {
    path: "power-of-attorney_2",
    redirectTo: "/dynamicformdataentry/power-of-attorney_2",
    pathMatch: "full",
  },
  {
    path: "power-of-attorney_3",
    redirectTo: "/dynamicformdataentry/power-of-attorney_3",
    pathMatch: "full",
  },
  {
    path: "power-of-attorney-new/:newItem",
    redirectTo: "/dynamicgrid/power-of-attorneys-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "power-of-attorney-view/:id",
    redirectTo: "/dynamicview/power-of-attorney-view/:id",
    pathMatch: "full",
  },
  {
    path: "power-of-attorney-edit/:id",
    redirectTo: "/dynamicedit/power-of-attorney-edit/:id",
    pathMatch: "full",
  },
  {
    path: "power-of-attorney-edit-save/:editItem",
    redirectTo: "/dynamicgrid/power-of-attorney-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "people-to-notify",
    redirectTo: "/dynamicformdataentry/person-to-notify_1",
    pathMatch: "full",
  },
  {
    path: "person-to-notify-intro",
    redirectTo: "/dynamicformdataentry/person-to-notify-intro",
    pathMatch: "full",
  },
  {
    path: "person-to-notify-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/person-to-notify-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "person-to-notify_1",
    redirectTo: "/dynamicformdataentry/person-to-notify_1",
    pathMatch: "full",
  },
  {
    path: "person-to-notify_2",
    redirectTo: "/dynamicformdataentry/person-to-notify_2",
    pathMatch: "full",
  },
  {
    path: "person-to-notify_3",
    redirectTo: "/dynamicformdataentry/person-to-notify_3",
    pathMatch: "full",
  },
  {
    path: "person-to-notify-new/:newItem",
    redirectTo: "/dynamicgrid/people-to-notify-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "person-to-notify-view/:id",
    redirectTo: "/dynamicview/person-to-notify-view/:id",
    pathMatch: "full",
  },
  {
    path: "person-to-notify-edit/:id",
    redirectTo: "/dynamicedit/person-to-notify-edit/:id",
    pathMatch: "full",
  },
  {
    path: "person-to-notify-edit-save/:editItem",
    redirectTo: "/dynamicgrid/people-to-notify-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "charities",
    redirectTo: "/dynamicformdataentry/charity_1",
    pathMatch: "full",
  },
  {
    path: "charity-intro",
    redirectTo: "/dynamicformdataentry/charity-intro",
    pathMatch: "full",
  },
  {
    path: "charity-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/charity-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "charity_1",
    redirectTo: "/dynamicformdataentry/charity_1",
    pathMatch: "full",
  },
  {
    path: "charity_2",
    redirectTo: "/dynamicformdataentry/charity_2",
    pathMatch: "full",
  },
  {
    path: "charity_3",
    redirectTo: "/dynamicformdataentry/charity_3",
    pathMatch: "full",
  },
  {
    path: "charity-new/:newItem",
    redirectTo: "/dynamicgrid/charities-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "charity-view/:id",
    redirectTo: "/dynamicview/charity-view/:id",
    pathMatch: "full",
  },
  {
    path: "charity-edit/:id",
    redirectTo: "/dynamicedit/charity-edit/:id",
    pathMatch: "full",
  },
  {
    path: "charity-edit-save/:editItem",
    redirectTo: "/dynamicgrid/charities-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "other-wishes",
    redirectTo: "/dynamicformdataentry/other-wish_1",
    pathMatch: "full",
  },
  {
    path: "other-wish-intro",
    redirectTo: "/dynamicformdataentry/other-wish-intro",
    pathMatch: "full",
  },
  {
    path: "other-wish-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/other-wish-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "other-wish_1",
    redirectTo: "/dynamicformdataentry/other-wish_1",
    pathMatch: "full",
  },
  {
    path: "other-wish_2",
    redirectTo: "/dynamicformdataentry/other-wish_2",
    pathMatch: "full",
  },
  {
    path: "other-wish_3",
    redirectTo: "/dynamicformdataentry/other-wish_3",
    pathMatch: "full",
  },
  {
    path: "other-wish-new/:newItem",
    redirectTo: "/dynamicgrid/other-wishes-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "other-wish-view/:id",
    redirectTo: "/dynamicview/other-wish-view/:id",
    pathMatch: "full",
  },
  {
    path: "other-wish-edit/:id",
    redirectTo: "/dynamicedit/other-wish-edit/:id",
    pathMatch: "full",
  },
  {
    path: "other-wish-edit-save/:editItem",
    redirectTo: "/dynamicgrid/other-wishes-grid/:editItem",
    pathMatch: "full",
  },

  { path: "my-debts", redirectTo: "/dynamicform/my-debts", pathMatch: "full" },
  {
    path: "my-debts/:id",
    redirectTo: "/dynamicform/my-debts",
    pathMatch: "full",
  },
  {
    path: "my-daily-life",
    redirectTo: "/dynamicform/my-daily-life",
    pathMatch: "full",
  },
  {
    path: "my-daily-life/:id",
    redirectTo: "/dynamicform/my-daily-life",
    pathMatch: "full",
  },
  {
    path: "my-digital-life",
    redirectTo: "/dynamicform/my-digital-life",
    pathMatch: "full",
  },
  {
    path: "my-digital-life/:id",
    redirectTo: "/dynamicform/my-digital-life",
    pathMatch: "full",
  },

  {
    path: "domain-names",
    redirectTo: "/dynamicformdataentry/domain-name_1",
    pathMatch: "full",
  },
  {
    path: "domain-name-intro",
    redirectTo: "/dynamicformdataentry/domain-name-intro",
    pathMatch: "full",
  },
  {
    path: "domain-name-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/domain-name-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "domain-name_1",
    redirectTo: "/dynamicformdataentry/domain-name_1",
    pathMatch: "full",
  },
  {
    path: "domain-name_2",
    redirectTo: "/dynamicformdataentry/domain-name_2",
    pathMatch: "full",
  },
  {
    path: "domain-name_3",
    redirectTo: "/dynamicformdataentry/domain-name_3",
    pathMatch: "full",
  },
  {
    path: "domain-name_4",
    redirectTo: "/dynamicformdataentry/domain-name_4",
    pathMatch: "full",
  },
  {
    path: "domain-name-new/:newItem",
    redirectTo: "/dynamicgrid/domain-name-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "domain-name-view/:id",
    redirectTo: "/dynamicview/domain-name-view/:id",
    pathMatch: "full",
  },
  {
    path: "domain-name-edit/:id",
    redirectTo: "/dynamicedit/domain-name-edit/:id",
    pathMatch: "full",
  },
  {
    path: "domain-name-edit-save/:editItem",
    redirectTo: "/dynamicgrid/domain-names-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "social-media",
    redirectTo: "/dynamicformdataentry/social-media_1",
    pathMatch: "full",
  },
  {
    path: "social-media-intro",
    redirectTo: "/dynamicformdataentry/social-media-intro",
    pathMatch: "full",
  },
  {
    path: "social-media-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/social-media-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "social-media_1",
    redirectTo: "/dynamicformdataentry/social-media_1",
    pathMatch: "full",
  },
  {
    path: "social-media_2",
    redirectTo: "/dynamicformdataentry/social-media_2",
    pathMatch: "full",
  },
  {
    path: "social-media_3",
    redirectTo: "/dynamicformdataentry/social-media_3",
    pathMatch: "full",
  },
  {
    path: "social-media-new/:newItem",
    redirectTo: "/dynamicgrid/social-media-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "social-media-view/:id",
    redirectTo: "/dynamicview/social-media-view/:id",
    pathMatch: "full",
  },
  {
    path: "social-media-edit/:id",
    redirectTo: "/dynamicedit/social-media-edit/:id",
    pathMatch: "full",
  },
  {
    path: "social-media-edit-save/:editItem",
    redirectTo: "/dynamicgrid/social-media-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "digital-devices",
    redirectTo: "/dynamicformdataentry/digital-device_1",
    pathMatch: "full",
  },
  {
    path: "digital-device-intro",
    redirectTo: "/dynamicformdataentry/digital-device-intro",
    pathMatch: "full",
  },
  {
    path: "digital-device-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/digital-device-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "digital-device_1",
    redirectTo: "/dynamicformdataentry/digital-device_1",
    pathMatch: "full",
  },
  {
    path: "digital-device_2",
    redirectTo: "/dynamicformdataentry/digital-device_2",
    pathMatch: "full",
  },
  {
    path: "digital-device_3",
    redirectTo: "/dynamicformdataentry/digital-device_3",
    pathMatch: "full",
  },
  {
    path: "digital-device-new/:newItem",
    redirectTo: "/dynamicgrid/digital-devices-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "digital-device-view/:id",
    redirectTo: "/dynamicview/digital-device-view/:id",
    pathMatch: "full",
  },
  {
    path: "digital-device-edit/:id",
    redirectTo: "/dynamicedit/digital-device-edit/:id",
    pathMatch: "full",
  },
  {
    path: "digital-device-edit-save/:editItem",
    redirectTo: "/dynamicgrid/digital-devices-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "password-managers",
    redirectTo: "/dynamicformdataentry/password-manager_1",
    pathMatch: "full",
  },
  {
    path: "password-manager-intro",
    redirectTo: "/dynamicformdataentry/password-manager-intro",
    pathMatch: "full",
  },
  {
    path: "password-manager-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/password-manager-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "password-manager_1",
    redirectTo: "/dynamicformdataentry/password-manager_1",
    pathMatch: "full",
  },
  {
    path: "password-manager_2",
    redirectTo: "/dynamicformdataentry/password-manager_2",
    pathMatch: "full",
  },
  {
    path: "password-manager_3",
    redirectTo: "/dynamicformdataentry/password-manager_3",
    pathMatch: "full",
  },
  {
    path: "password-manager-new/:newItem",
    redirectTo: "/dynamicgrid/password-manager-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "password-manager-view/:id",
    redirectTo: "/dynamicview/password-manager-view/:id",
    pathMatch: "full",
  },
  {
    path: "password-manager-edit/:id",
    redirectTo: "/dynamicedit/password-manager-edit/:id",
    pathMatch: "full",
  },
  {
    path: "password-manager-edit-save/:editItem",
    redirectTo: "/dynamicgrid/password-managers-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "email",
    redirectTo: "/dynamicformdataentry/email_1",
    pathMatch: "full",
  },
  {
    path: "email-intro",
    redirectTo: "/dynamicformdataentry/email-intro",
    pathMatch: "full",
  },
  {
    path: "email-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/email-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "email_1",
    redirectTo: "/dynamicformdataentry/email_1",
    pathMatch: "full",
  },
  {
    path: "email_2",
    redirectTo: "/dynamicformdataentry/email_2",
    pathMatch: "full",
  },
  {
    path: "email_3",
    redirectTo: "/dynamicformdataentry/email_3",
    pathMatch: "full",
  },
  {
    path: "email-new/:newItem",
    redirectTo: "/dynamicgrid/email-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "email-view/:id",
    redirectTo: "/dynamicview/email-view/:id",
    pathMatch: "full",
  },
  {
    path: "email-edit/:id",
    redirectTo: "/dynamicedit/email-edit/:id",
    pathMatch: "full",
  },
  {
    path: "email-edit-save/:editItem",
    redirectTo: "/dynamicgrid/email-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "cloud-storage",
    redirectTo: "/dynamicformdataentry/cloud-storage_1",
    pathMatch: "full",
  },
  {
    path: "cloud-storage-intro",
    redirectTo: "/dynamicformdataentry/cloud-storage-intro",
    pathMatch: "full",
  },
  {
    path: "cloud-storage-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/cloud-storage-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "cloud-storage_1",
    redirectTo: "/dynamicformdataentry/cloud-storage_1",
    pathMatch: "full",
  },
  {
    path: "cloud-storage_2",
    redirectTo: "/dynamicformdataentry/cloud-storage_2",
    pathMatch: "full",
  },
  {
    path: "cloud-storage_3",
    redirectTo: "/dynamicformdataentry/cloud-storage_3",
    pathMatch: "full",
  },
  {
    path: "cloud-storage-new/:newItem",
    redirectTo: "/dynamicgrid/cloud-storage-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "cloud-storage-view/:id",
    redirectTo: "/dynamicview/cloud-storage-view/:id",
    pathMatch: "full",
  },
  {
    path: "cloud-storage-edit/:id",
    redirectTo: "/dynamicedit/cloud-storage-edit/:id",
    pathMatch: "full",
  },
  {
    path: "cloud-storage-edit-save/:editItem",
    redirectTo: "/dynamicgrid/cloud-storage-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "e-commerce",
    redirectTo: "/dynamicformdataentry/e-commerce_1",
    pathMatch: "full",
  },
  {
    path: "e-commerce-intro",
    redirectTo: "/dynamicformdataentry/e-commerce-intro",
    pathMatch: "full",
  },
  {
    path: "e-commerce-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/e-commerce-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "e-commerce_1",
    redirectTo: "/dynamicformdataentry/e-commerce_1",
    pathMatch: "full",
  },
  {
    path: "e-commerce_2",
    redirectTo: "/dynamicformdataentry/e-commerce_2",
    pathMatch: "full",
  },
  {
    path: "e-commerce-new/:newItem",
    redirectTo: "/dynamicgrid/e-commerce-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "e-commerce-view/:id",
    redirectTo: "/dynamicview/e-commerce-view/:id",
    pathMatch: "full",
  },
  {
    path: "e-commerce-edit/:id",
    redirectTo: "/dynamicedit/e-commerce-edit/:id",
    pathMatch: "full",
  },
  {
    path: "e-commerce-edit-save/:editItem",
    redirectTo: "/dynamicgrid/e-commerce-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "loyalty-accounts",
    redirectTo: "/dynamicformdataentry/loyalty-accounts_1",
    pathMatch: "full",
  },
  {
    path: "loyalty-account-intro",
    redirectTo: "/dynamicformdataentry/loyalty-account-intro",
    pathMatch: "full",
  },
  {
    path: "loyalty-account-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/loyalty-account-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "loyalty-account_1",
    redirectTo: "/dynamicformdataentry/loyalty-account_1",
    pathMatch: "full",
  },
  {
    path: "loyalty-account_2",
    redirectTo: "/dynamicformdataentry/loyalty-account_2",
    pathMatch: "full",
  },
  {
    path: "loyalty-account_3",
    redirectTo: "/dynamicformdataentry/loyalty-account_3",
    pathMatch: "full",
  },
  {
    path: "loyalty-account-new/:newItem",
    redirectTo: "/dynamicgrid/loyalty-account-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "loyalty-account-view/:id",
    redirectTo: "/dynamicview/loyalty-account-view/:id",
    pathMatch: "full",
  },
  {
    path: "loyalty-account-edit/:id",
    redirectTo: "/dynamicedit/loyalty-account-edit/:id",
    pathMatch: "full",
  },
  {
    path: "loyalty-account-edit-save/:editItem",
    redirectTo: "/dynamicgrid/loyalty-account-grid/:editItem",
    pathMatch: "full",
  },

  {
    path: "other-digital-accounts",
    redirectTo: "/dynamicformdataentry/other-digital-accounts_1",
    pathMatch: "full",
  },
  {
    path: "other-digital-account-intro",
    redirectTo: "/dynamicformdataentry/other-digital-account-intro",
    pathMatch: "full",
  },
  {
    path: "other-digital-account-intro-isNFZ",
    redirectTo: "/dynamicformdataentry/other-digital-account-intro?d=nfzRedirection",
    pathMatch: "full",
  },
  {
    path: "other-digital-account_1",
    redirectTo: "/dynamicformdataentry/other-digital-account_1",
    pathMatch: "full",
  },
  {
    path: "other-digital-account_2",
    redirectTo: "/dynamicformdataentry/other-digital-account_2",
    pathMatch: "full",
  },
  {
    path: "other-digital-account-new/:newItem",
    redirectTo: "/dynamicgrid/other-digital-account-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "other-digital-account-view/:id",
    redirectTo: "/dynamicview/other-digital-account-view/:id",
    pathMatch: "full",
  },
  {
    path: "other-digital-account-edit/:id",
    redirectTo: "/dynamicedit/other-digital-account-edit/:id",
    pathMatch: "full",
  },
  {
    path: "other-digital-account-edit-save/:editItem",
    redirectTo: "/dynamicgrid/other-digital-account-grid/:editItem",
    pathMatch: "full",
  },

  { path: "log-in", component: LoginComponent },
  { path: "sponsor-page", component: SponsorPageComponent },
  { path: "reset-password/:activationCode", component: ResetPasswordComponent },
  { path: "resetpasswordemail", component: ResetPasswordEmailComponent },
  {
    path: "resetpasswordemailsent",
    component: ResetPasswordEmailSentComponent,
  },
  { path: "resetpasswordcontact", component: ResetPasswordContactComponent },

  { path: "dynamicform/:templateName", component: DynamicFormComponent },
  {
    path: "dynamicformdataentry/:templateName",
    component: DynamicFormDataEntryComponent,
  },
  {
    path: "dynamicformdataentry/:templateName/:Id",
    component: DynamicFormDataEntryComponent,
  },
  {
    path: "dynamicgrid/:templateName/:action",
    component: DynamicGridComponent,
  },
  { path: "dynamicgrid/:templateName", component: DynamicGridComponent },
  { path: "dynamicview/:templateName/:Id", component: DynamicViewComponent },
  { path: "dynamicedit/:templateName/:Id", component: DynamicEditComponent },

  // Others
  {
    path: "delegates",
    redirectTo: "/dynamicgrid/delegates-grid",
    pathMatch: "full",
  },
  {
    path: "delegate_1",
    redirectTo: "/dynamicformdataentry/delegate_1",
    pathMatch: "full",
  },
  {
    path: "delegate_2",
    redirectTo: "/dynamicformdataentry/delegate_2",
    pathMatch: "full",
  },
  {
    path: "delegate_3_1",
    redirectTo: "/dynamicformdataentry/delegate_3_1",
    pathMatch: "full",
  },
  {
    path: "delegate_3_2",
    redirectTo: "/dynamicformdataentry/delegate_3_2",
    pathMatch: "full",
  },
  {
    path: "delegate_3_3",
    redirectTo: "/dynamicformdataentry/delegate_3_3",
    pathMatch: "full",
  },
  {
    path: "delegate_3_4",
    redirectTo: "/dynamicformdataentry/delegate_3_4",
    pathMatch: "full",
  },
  {
    path: "delegate_3_5",
    redirectTo: "/dynamicformdataentry/delegate_3_5",
    pathMatch: "full",
  },
  {
    path: "delegate_3_6",
    redirectTo: "/dynamicformdataentry/delegate_3_5",
    pathMatch: "full",
  },
  {
    path: "delegate_4",
    redirectTo: "/dynamicformdataentry/delegate_4",
    pathMatch: "full",
  },
  {
    path: "delegate-new/:newItem",
    redirectTo: "/dynamicgrid/delegates-grid/:newItem",
    pathMatch: "full",
  },
  {
    path: "delegate-view/:id",
    redirectTo: "/dynamicview/delegate-view/:id",
    pathMatch: "full",
  },
  {
    path: "delegate-edit/:id",
    redirectTo: "/dynamicedit/delegate-edit/:id",
    pathMatch: "full",
  },
  {
    path: "delegate-edit-save/:editItem",
    redirectTo: "/dynamicgrid/delegates-grid/:editItem",
    pathMatch: "full",
  },
  {
    path: "delegate_invitation_sent",
    component: DelegateInvitationSentComponent,
  },

  { path: "sign-up-completed/:id", component: SignUpCompletedComponent },

  {
    path: "about-me_1/:id",
    redirectTo: "/dynamicedit/about-me_1/:id",
    pathMatch: "full",
  },
  {
    path: "about-me_2/:id",
    redirectTo: "/dynamicedit/about-me_2/:id",
    pathMatch: "full",
  },
  {
    path: "about-me_3/:id",
    redirectTo: "/dynamicedit/about-me_3/:id",
    pathMatch: "full",
  },
  {
    path: "about-me-edit-no-refcode/:id",
    redirectTo: "//dynamicedit/about-me-edit-no-refcode/:id",
    pathMatch: "full",
  },
  {
    path: "about-me-edit/:id",
    redirectTo: "//dynamicedit/about-me-edit/:id",
    pathMatch: "full",
  },
  {
    path: "professional-funded-about-me-edit/:id",
    redirectTo: "//dynamicedit/professional-funded-about-me-edit/:id",
    pathMatch: "full",
  },
  {
    path: "professional-about-me-edit/:id",
    redirectTo: "//dynamicedit/professional-about-me-edit/:id",
    pathMatch: "full",
  },
  { path: "my-logout", redirectTo: "/", pathMatch: "full" },
  { path: "sign-up-password", component: SignUpPasswordComponent },
  { path: "delegate-home-page", component: DelegateHomePageComponent },
  { path: "financial-summaries", component: FinancialSummariesComponent },
  { path: "shared-plan-summary/:id", component: SharedPlanSummaryComponent },
  { path: "testing", component: XTestingComponent },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { scrollPositionRestoration: "top" }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
